module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Ha.0b9a4f78.png";